import { jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { gql } from "@apollo/client";
import { DateTime } from "luxon";
import { formattedPrice } from "@withfriendsco/wf-components";
gql `
fragment MembershipShopifyOrder on ShopifyOrder {
  id
  createdAt
  customerMembershipTotal
  customerCurrencyCode
  status
}
`;
const MembershipShopifyOrder = ({ shopifyOrder, membershipName }) => {
    const createdAt = DateTime.fromISO(shopifyOrder.createdAt);
    const customerMembershipTotal = formattedPrice(shopifyOrder.customerMembershipTotal, shopifyOrder.customerCurrencyCode);
    return (_jsxs("div", { className: "leading-loose", children: [createdAt.toLocaleString(), " - ", membershipName, ": ", customerMembershipTotal, " - ", shopifyOrder.status] }));
};
export default MembershipShopifyOrder;
